import React, { useEffect, useContext, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogAction, useModal } from '../../../../../function/useModal';
import NumericEntry_input_EmptyUse from '../../../../atoms/Input/NumericEntry_input_EmptyUse';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../../atoms/Dialog/MessageDialog';

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Checkbox, TextField } from '@material-ui/core';

import { TableBaseStyle } from './LowPassFilterStyle'
import {
  PLCcollectSettingType,
} from './../CollectSettingDefine';

type LowPassFilterDialogProps ={
  dialog: DialogAction<LowPassFilterDialogResponse>;
  plcCollectSettingType:PLCcollectSettingType;
  isIoT: boolean;
  updateItem:(item: PLCcollectSettingType) => void;
}

export type LowPassFilterDialogResponse = {
  result: PLCcollectSettingType;
};

const LowPassFilterDialog: React.FC<LowPassFilterDialogProps> = (props: LowPassFilterDialogProps) =>{

  const { t } = useTranslation();
  const tableBaseStyle = TableBaseStyle();
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [plcCollectSettingType,SetPlcCollectSettingType] =useState<PLCcollectSettingType>(props.plcCollectSettingType);
  const [flgUpdate, setFlgUpdate] = useState<boolean>(false);

  const [dlgmsg, setDlgmsg] = useState<string>('');
  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('LowPassFilterDialog.はい', 'はい')}
      cancel={t('LowPassFilterDialog.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  /**
   * 設定処理
   */
  const settingAction = () =>{
    if (flgUpdate){
      setDlgmsg(t('LowPassFilterDialog.設定を更新しますか?', '設定を更新しますか?'));
      actCfmDlg
        .open()
        .apply((_) => {
          setFlgUpdate(false);
          console.debug(t('LowPassFilterDialog.実行', '実行'));
          
          //設定値のチェックを行う
          if(settingsCheck()){
          props.updateItem(plcCollectSettingType);
          props.dialog.apply({result: plcCollectSettingType });
          }
        })
        .cancel(() => {
          console.debug(t('LowPassFilterDialog.キャンセル', 'キャンセル'));
        });
    }
  }

  /**
   * キャンセル処理
   */
  const cancelAction = () => {
    //編集済みの場合確認する
    if (flgUpdate) {
      setDlgmsg(
        t(
          'LowPassFilterDialog.保存していないデータを破棄しますよろしいですか',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          setFlgUpdate(false);
          console.debug(t('LowPassFilterDialog.実行', '実行'));
          props.dialog.cancel();

        })
        .cancel(() => {
          console.debug(t('LowPassFilterDialog.キャンセル', 'キャンセル'));
        });
    } else {
        console.debug('LowPassFilterDialog closeAction complete');

        props.dialog.cancel();
    }
  };
  
  /**
   * フィルタ次数変更
   * @param item 
   */
  const changeFilterOrder = (item :number)=>{
    console.debug(['LowPassFilterDialog FilterOrder changeAction',plcCollectSettingType.FilterOrder,item ]);
    SetPlcCollectSettingType({
      ...plcCollectSettingType,
      FilterOrder: item,
    });
    setFlgUpdate(true)
  }

  /**
   * カットオフ周波数変更
   * @param item 
   */
  const changeCutOffFreq = (item :number)=>{
    console.debug(['LowPassFilterDialog CutOffFreq changeAction',plcCollectSettingType.CutOffFreq,item ]);
    SetPlcCollectSettingType({
      ...plcCollectSettingType,
      CutOffFreq: item,
    });
    setFlgUpdate(true)
  }
  /**
   * ローパスフィルタON/OFF切替
   * @param checked 
   */
  const changeLowPass =(checked :boolean)=>{
    console.debug(['LowPassFilterDialog LowPassFilter changeAction',plcCollectSettingType.LowPassFlg,checked ]);
    SetPlcCollectSettingType({
      ...plcCollectSettingType,
      LowPassFlg: checked ? true : false,
    });
    setFlgUpdate(true)
  }

  /**
   * 設定値チェック
   */
  const settingsCheck = () : boolean =>{
    console.debug(['test test',plcCollectSettingType.CutOffFreq ,plcCollectSettingType.FilterOrder ]);
    if(plcCollectSettingType.CutOffFreq === null){
      console.warn('カットオフ周波数変更値がnullです');
      setDlgmsg(t('LowPassFilterDialog.カットオフ周波数変更値がnullです', 'カットオフ周波数変更値がnullです'));
      actMsgDlg.open();
      return false;
    }
    if(plcCollectSettingType.FilterOrder === null ){
      console.warn('フィルタ次数変更値がnullです');
      setDlgmsg(t('LowPassFilterDialog.フィルタ次数変更値がnullです', 'フィルタ次数変更値がnullです'));
      actMsgDlg.open();
      return false;
    }
    console.debug(['LowPassFilterDialog Settings Check Complete' ]);
    return true;
  }

  return(
    <>
      <Dialog
        open={true}
        fullScreen={false}
        maxWidth="xl"
      >
        <DialogTitle>{t('LowPassFilterDialog.ローパスフィルタ設定', 'ローパスフィルタ設定')}</DialogTitle>
        <DialogContent>
          <TableContainer className={tableBaseStyle.tableContainer}>
            <Table aria-label="lowPassFilter">
              <TableHead>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell} width={200}>{t('LowPassFilterDialog.項目', '項目')}</TableCell>
                  <TableCell className={tableBaseStyle.headerCell} width={100}>{t('LowPassFilterDialog.設定値', '設定値')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/**ローパスフィルタON/OFF切替 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                    {t('LowPassFilterDialog.フィルタ有効', 'フィルタ有効')}
                  </TableCell>
                  <TableCell align="center" className={tableBaseStyle.dialogBodyCellCenter} width={100}>
                    <Checkbox checked={plcCollectSettingType.LowPassFlg}
                      onChange={(e, chk) => 
                        changeLowPass(chk)
                      } 
                    />
                  </TableCell>
                </TableRow>
                {/**カットオフ周波数 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                    {t('LowPassFilterDialog.カットオフ周波数', 'カットオフ周波数')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={100}>
                    <NumericEntry_input_EmptyUse
                      className={tableBaseStyle.textFieldDialog}
                      value={plcCollectSettingType.CutOffFreq === null ? 0 : Number(plcCollectSettingType.CutOffFreq)}
                      minValueLimit={1}
                      maxValueLimit={props.isIoT === true ? 4999:6249}  //クラウド版：4999Hz、オンプレ版：6249Hz
                      fixed={0}
                      onChange={(val) => {
                        changeCutOffFreq(val === null?0:val);
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/**フィルタ次数 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={200}>
                    {t('LowPassFilterDialog.フィルタ次数', 'フィルタ次数')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.dialogBodyCellLeft} width={100}>
                    <NumericEntry_input_EmptyUse
                      className={tableBaseStyle.textFieldDialog}
                      value={plcCollectSettingType.FilterOrder === null ? 0 : Number(plcCollectSettingType.FilterOrder)}
                      minValueLimit={1}
                      maxValueLimit={20}
                      fixed={0}
                      onChange={(val) => {
                        changeFilterOrder(val=== null?0:val);
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          {/**設定ボタン */}
          <Button
            className={tableBaseStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={(e) => {
              settingAction();
            }}
          >
            {t('LowPassFilterDialog.設定', '設定')}
          </Button>
          {/**キャンセルボタン */}
          <Button
            className={tableBaseStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => {
              cancelAction();
            }}
          >
            {t('LowPassFilterDialog.キャンセル', 'キャンセル')}
          </Button>
        </DialogActions>
      </Dialog>
      {cfmdlg}
      {msgdlg}
    </>
  )
};
export default LowPassFilterDialog;